import { LoaderFunction, useFetcher } from "react-router-dom";
import {
  DynamicLink,
  generateDynamicLink,
  userPreferenceDelete,
  UserPreferenceKey,
  userPreferenceUpdate,
  userUpdate,
} from "../../../../common/api/decimal/methods/user.ts";
import { DecimalResult } from "../../../../common/api/decimal/utils.ts";

export const updateUser: LoaderFunction = async ({
  request,
}): Promise<unknown> => {
  const formData = await request.formData();
  const locale = formData.get("locale");
  if (locale && typeof locale === "string") {
    return userUpdate({ locale });
  }
  return null;
};

export const updateUserPreference: LoaderFunction = async ({
  request,
  params,
}): Promise<DecimalResult<unknown>> => {
  const id = params.id;
  const method = request.method;
  if (
    id &&
    Object.values(UserPreferenceKey).includes(id as UserPreferenceKey)
  ) {
    const typedPreferenceKey = id as UserPreferenceKey;
    if (method === "PUT") {
      const json = (await request.json()) as NonNullable<unknown>;
      return userPreferenceUpdate(typedPreferenceKey, json);
    }
    if (method === "DELETE") {
      return userPreferenceDelete(typedPreferenceKey);
    }
  }
  return Promise.resolve({ ok: false, meta: {} });
};

export function useUserPreferenceFetcher() {
  return useFetcher<DecimalResult<unknown>>();
}

export const getDynamicLink: LoaderFunction = async ({ request }) => {
  const url = new URL(request.url);
  const destination = url.searchParams.get("destination");
  if (destination) {
    return generateDynamicLink(destination);
  }
  return null;
};

export function useDynamicLinkFetcher() {
  return useFetcher<DecimalResult<DynamicLink>>();
}
